export class NetworkError extends Error {
	constructor() {
		super("Network error");
	}
}

export class NotFoundError extends Error {
	constructor() {
		super("The resource you requested was not found.");
	}
}

export class ServerError extends Error {
	constructor() {
		super("There was a server error.");
	}
}

export class BadRequestError extends Error {
	constructor() {
		super("There was a bad request error.");
	}
}
